import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 图片处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
// assets
import arrow from '../../assets/arrow.png';
import player from '../../assets/player.png';
const Content = ({ content }) => {

    const { title, thumbnails, posterUrl, url } = content[0];

return (

    <div className={styles.content}>
        <div className={styles.slide}>
            <a href={url} target="_blank" rel="noreferrer">
                <img src={ formatImage(getThumbnail(content[0]))} alt="" className={styles.slideImg} />
                <div className={styles.itemTitle}>{title}</div>
                <div className={styles.itemPlayer}>
                    <img src={player} alt="" />
                </div>
            </a>
        </div>
        <div className={styles.slide}>
            {
                    content.splice(1).map((item, index) => {

                        const { url, base62Id, title } = item;
                        
                    return (
                            <div className={styles.item} key={base62Id}>
                                <a href={url} target="_blank" rel="noreferrer">
                                    {title}
                                </a>
                            </div>
                        );
                    })
            }
        </div>
            
    </div>

    );
};

Content.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Content);
